import { createProductActions } from './productActions';
import { createWallActions } from './wallActions';
import { createSelectionActions } from './selectionActions';

export const createActions = (set, get) => ({
  ...createProductActions(set, get),
  ...createWallActions(set, get),
  ...createSelectionActions(set, get),
});
